export const INIT = 'initCompetence';
export const FETCH_ITEM = 'fetchItem';
export const SET_FOOTER = 'setFooter';
export const PROGRAM_TITLE = 'Программы';
export const PROGRAM_CARD = 'ItemSingle';
export const SET_PROGRAMS = 'setPrograms';
export const PROFESSION_TITLE = 'Профессии';
export const FETCH_PROGRAMS = 'fetchPrograms';
export const STORE_MODULE_NAME = 'competence';
export const SET_COMPETENCE = 'setCompetence';
export const SET_PROFESSIONS = 'setProfessions';
export const SET_COMP_MODULES = 'setCompModules';
export const SET_NOTHING_FOUND = 'setNothingFound';
export const FETCH_PROFESSIONS = 'fetchProfessions';
export const PROFESSION_CARD = 'ProfessionListCard';
export const FETCH_COMP_MODULES = 'fetchCompModules';



// WEBPACK FOOTER //
// ./src/pages/competences/card/consts.ts